import { generateDynamicPath } from 'common/utils/routing';

export const NattersRoutes = {
  Natters: '/natters',
  NattersList: '/natters/list',
  NattersListHosted: '/natters/list/hosted',
  NattersListOpen: '/natters/list/open',
  NattersWizard: '/natters/wizard/:id?',
  NatterDetails: '/natters/:id',
  NatterPublic: '/natters/:id/public',
  NatterJoin: '/natters/:id/join',
  NatterRoom: '/natters/:id/room',
  NatterWaiting: '/natters/:id/waiting',
  NatterUnmatched: '/natters/:id/unmatched',
  NatterPostSurvey: '/natters/:id/post-survey',
  NatterCancel: '/natters/:id/cancel',
  NatterEnded: '/natters/:id/ended',
  NatterAvailability: '/natters/:id/availability',
  NatterAddToCalendar: '/natters/:id/calendar',
} as const;

export const NattersRoutesPublic = [NattersRoutes.NatterPublic, NattersRoutes.NatterAvailability];

// Routes where Intercom widget should be hidden (natters module)
export const INTERCOM_HIDDEN_ROUTES: readonly string[] = [
  // Live natter routes
  NattersRoutes.NatterJoin,
  NattersRoutes.NatterRoom,
  NattersRoutes.NatterWaiting,
  NattersRoutes.NatterUnmatched,
  NattersRoutes.NatterPostSurvey,
  NattersRoutes.NatterCancel,
  NattersRoutes.NatterEnded,
  // Public routes
  ...NattersRoutesPublic,
];

// Routes where Intercom should be shown to anonymous (unauthenticated) users (natters module)
export const INTERCOM_PUBLIC_ROUTES: readonly string[] = [NattersRoutes.NatterPublic];

export const getNatterDetailsPath = (id: string, isAbsolute = false) =>
  generateDynamicPath(NattersRoutes.NatterDetails, { id }, undefined, { isAbsolute });

export const getNatterPublicPath = (id: string, isAbsolute = false) =>
  generateDynamicPath(NattersRoutes.NatterPublic, { id }, undefined, { isAbsolute });
